import React, { useState, useEffect, useRef } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import "./NavBarr.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/images/kalemon-academy.png";
import { useTranslation } from "react-i18next";
import LanguageButton from "../LanguageButton/LangaugeButton"

function NavBarr() {
  const [navbar, setNavbar] = useState(false);

  const { t } = useTranslation();

  const collapseButtonRef = useRef(null);
  const collapseButtonRef2 = useRef(null);

  const changeNavColor = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  useEffect(() => {
    changeNavColor();
    window.addEventListener("scroll", changeNavColor);
  });

  const location = useLocation();

  const handleCollapse = () => {
    if (collapseButtonRef.current) {
      collapseButtonRef.current.click(); // Close the collapse toggle button
    }
  };

  const handleCollapseDropdown = () => {
    if (collapseButtonRef2.current) {
      collapseButtonRef2.current.click(); // Close the collapse toggle button
    }
  };

  // Function to check if the device is a mobile device
  const isMobileDevice = () => {
    return window.innerWidth <= 768; // Adjust this threshold according to your design
  };

  // Call handleCollapse only on mobile devices
  const handleMobileCollapse = () => {
    if (isMobileDevice()) {
      handleCollapse();
    }
  };


  return (
    <Navbar expand="lg" className={navbar ? "navbar-dark" : "navbar"}>
      <Container>
        <Link className="mob-logo" to="/">
          <img className="logo" src={logo} alt="" width="250px" style={{height:"40px", objectFit: "cover" }} />
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Link className="not-mob-logo" to="/">
          <img className="logo" src={logo} alt="" width="250px" style={{height:"40px", objectFit: "cover" }} />
          </Link>
          <Nav className="d-flex justify-content-center">
            <div className="parent_links mx-2">
              <Link
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={location.pathname === "/" ? "active-link" : "links"}
                to="/"
              >
                {t("home")}
              </Link>
            </div>
           <div  className="d-flex align-items-center justify-content-center">
              <NavDropdown ref={collapseButtonRef2} title={t("programs")} id="basic-nav-dropdown" className={location.pathname === "/bareq" || location.pathname === "/arabic-for-life" || location.pathname === "/kalemon-k12" || location.pathname === "/arabic-specialized" || location.pathname === "/arabic-calligraphy" || location.pathname === "/kalemon-levels" ? "active-drop-links drop-links" : "drop-links"}>
                {/* <Link to="/bareq" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/bareq" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("bareq")}  </p> </div>  </Link> */}
                <Link to="/arabic-for-life" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/arabic-for-life" ? "active-dlink2 dlink2" : "dlink2"}> <p> {t("arabic_for_life")}  </p> </div>  </Link>
                <Link to="/arabic-calligraphy" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/arabic-calligraphy" ? "active-dlink2 dlink2" : "dlink2"}> <p> {t("arabic_calligraphy")}   </p> </div>  </Link>
                <Link to="/conversation-program" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/conversation-program" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("conversation_program")}  </p> </div>  </Link>
                <Link to="/kalemon-k12" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/kalemon-k12" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("kalemon_k12")}  </p> </div>  </Link>
                <Link to="/kalemon-levels" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/kalemon-levels" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("kalemon_levels")}  </p> </div>  </Link>
                <Link to="/arabic-specialized" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/arabic-specialized" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("specialized_arabic")}  </p> </div>  </Link>
                <Link to="/teachers" > <div onClick={() => { handleMobileCollapse(); handleCollapseDropdown(); }} className={location.pathname === "/teachers" ? "active-dlink1 dlink1" : "dlink1"}> <p> {t("teacher_training_diploma")}  </p> </div>  </Link>
  
              </NavDropdown>
           </div>

            <div className="parent_links mx-2">
              <Link
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={location.pathname === "/why-kalemon" ? "active-link" : "links"}
                to="/why-kalemon"
              >
                {t("why_kalemon")}
              </Link>
            </div>

            <div className="parent_links mx-2">
              <Link
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={location.pathname === "/how-we-learn" ? "active-link" : "links"}
                to="/how-we-learn"
              >
                {t("how-you-learn")}
              </Link>
            </div>

            {/* <div className="parent_links mx-2">
              <Link
               onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={location.pathname === "/news" ? "active-link" : "links"}
                // to="/news"
              >
                {t("Blog & News")}
              </Link>
            </div> */}

            <div className="parent_links mx-2">
              <Link
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={location.pathname === "/our-teachers" ? "active-link" : "links"}
                to="/our-teachers"
              >
                {t ("our_teachers")}
              </Link>
            </div>

          </Nav>
          <div className="d-flex align-items-center justify-content-between">
            <LanguageButton />
            <div className="d-flex align-items-center">
              <Link to="/contact-us">
                <button className="create-account"> {t("contact-us")} </button>
              </Link>
              {/* <Link to="/login">
                <button className="create-account2"> {t("login")} </button>
              </Link> */}
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBarr;
